import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { thumbSrc } from "../api/client";
// Preview image for an event list row. Central events load their JPEG from the
// cloud (/api/media/<ref>/thumb); a missing thumbnail (404) or a shard event
// with no thumb path falls back to the "cam N" placeholder.
export default function Thumbnail({ ev }) {
    const [error, setError] = useState(false);
    const src = thumbSrc(ev);
    if (src && !error) {
        return (_jsx("img", { src: src, alt: ev.sCameraName ? ev.sCameraName : `cam ${ev.bCamera}`, loading: "lazy", onError: () => setError(true) }));
    }
    return _jsxs("span", { className: "thumb-placeholder", children: ["cam ", ev.bCamera] });
}
